<template>
  <div class="detail_root site_content" v-if="initComplete">
    <!-- 面包屑 -->
    <div class="breadcrumb_w">
      <SiteBreadcrumb />
    </div>

    <div class="top_box">
      <div class="project_title">{{ itemDetail.title }}</div>

      <div class="project_main">
        <GoodsPreview :itemDetail="itemDetail" />

        <ProMain :itemDetail="itemDetail" />

        <RightBlock :itemDetail="itemDetail" />
      </div>
    </div>

    <RiskTip :projectRisk = "itemDetail.projectRisk"/>

    <div class="main_box">
      <div class="main_l">
        <TabContent :itemDetail="itemDetail" />
      </div>
      <div class="main_r">
        <SideRecommend :itemDetail="itemDetail" />
      </div>
    </div>
  </div>
</template>

<script>
import SiteBreadcrumb from '@/components/base/SiteBreadcrumb.vue'

import GoodsPreview from "./GoodsPreview.vue";
import ProMain from "./ProMain.vue";
import RightBlock from "./RightBlock.vue";
import RiskTip from "./RiskTip.vue";
import TabContent from "./TabContent.vue";
import SideRecommend from "./SideRecommend.vue";

import { auction_info } from "@/api/portal";
import { uuid, numTurnText } from "@/utils";
import { mapGetters } from "vuex";

export default {
  components: {
    SiteBreadcrumb,
    GoodsPreview,
    ProMain,
    RightBlock,
    RiskTip,
    TabContent,
    SideRecommend,
  },
  metaInfo() {
    return {
      title: `${this.itemDetail?.title ? this.itemDetail.title + " - " : ""}${
        this.siteInfo?.name
      }`,
      meta: [
        {
          name: "keywords",
          content: `${
            this.itemDetail?.title ? this.itemDetail.title + "," : ""
          }${
            this.itemDetail?.project?.targets?.map((i) => i.name).join(",")
              ? this.itemDetail?.project?.targets?.map((i) => i.name).join(",")
              : ""
          }`,
        },
        {
          name: "description",
          content: `${
            this.itemDetail?.project?.purpose
              ? this.itemDetail.project.purpose
              : this.itemDetail?.project?.describe
              ? this.itemDetail.project.describe
              : ""
          }`,
        },
      ],
    };
  },
  data() {
    return {
      itemDetail: null, // 项目详情数据
      initComplete: false,
    };
  },
  computed: {
    ...mapGetters(["siteInfo"]),
  },
  created() {
    this.getItemDetail(this.$route.query.projectNo);
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    // 获取项目详情 api
    async getItemDetail(projectNo) {
      const { data } = await auction_info({
        projectNo: projectNo,
        uid: uuid(13),
      }); // 如果是动态变化的数据，必须设置uid，否则浏览器会缓存！

      this.itemDetail = JSON.parse(JSON.stringify(data));
      this.initComplete = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.detail_root {
  margin: 0 auto 20px auto;

}
.top_box {
  display: flex;
  flex-direction: column;
  padding: 0 20px 10px 20px;
  background-color: #fff;
  .project_title {
    margin: 10px 0;
  }
  .project_main {
    display: flex;
  }
}
.main_box {
  display: flex;
  justify-content: space-between;
  .main_l {
    background-color: #fff;
  }
}
</style>
